export class Constants {
  public static readonly TenantId = 'webEdiTenantId' // xiaTenantId
  public static readonly TenantName = 'webEdiTenantName' // xiaTenantName
  public static readonly TenantConfig = 'webEdiTenantConfig'
  public static readonly HttpHeaderETag = 'ETag'
  public static readonly RetryAfter = 'retry-after'
  public static readonly LocationUrl = 'location'
  public static readonly HttpHeaderCorrelationId = 'X-Correlation-ID'
  public static readonly HttpHeaderTenantId = 'Xia-TenantId'
  public static readonly HttpHeaderProjectId = 'Xia-ProjectId'
  public static readonly DefaultRefreshInterval = 5000

  public static readonly SESSION_STORAGE_TABLE_KEY = 'webEDI:tables'
  public static readonly LOCAL_STORAGE_PANELS_KEY = 'webEDI:panels'
  public static readonly LOCAL_STORAGE_LANGUAGE_KEY = 'webEDI:language'

  public static readonly MAX_ROWS_FOR_PRINT = 9999
  public static readonly MaxSuppliers = '500'
}
